/**
 * Shinohara Intensity Ratio Series Component
 *
 * Renders two separate lines for the Shinohara indicator:
 * - Strong Ratio (orange): Measures interday strength
 * - Weak Ratio (blue): Measures intraday weakness
 *
 * Both lines oscillate around 100:
 * - Values > 100: Selling pressure dominates
 * - Values < 100: Buying pressure dominates
 */

import React, { Component } from "react";
import PropTypes from "prop-types";
import LineSeries from "./LineSeries";
import { strokeDashTypes } from "../utils";

class ShinoharaSeries extends Component {
  constructor(props) {
    super(props);
    this.yAccessorForStrongRatio = this.yAccessorForStrongRatio.bind(this);
    this.yAccessorForWeakRatio = this.yAccessorForWeakRatio.bind(this);
  }

  yAccessorForStrongRatio(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).strongRatio;
  }

  yAccessorForWeakRatio(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).weakRatio;
  }

  render() {
    const { className, onContextMenu } = this.props;
    const { strokeStrongRatio, strokeWeakRatio } = this.props;

    return (
      <g className={className}>
        {/* Strong Ratio line (orange) */}
        <LineSeries
          yAccessor={this.yAccessorForStrongRatio}
          stroke={strokeStrongRatio}
          onContextMenu={onContextMenu}
        />
        {/* Weak Ratio line (blue) */}
        <LineSeries
          yAccessor={this.yAccessorForWeakRatio}
          stroke={strokeWeakRatio}
          onContextMenu={onContextMenu}
        />
      </g>
    );
  }
}

ShinoharaSeries.propTypes = {
  className: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  strokeStrongRatio: PropTypes.shape({
    color: PropTypes.string,
    opacity: PropTypes.number,
    width: PropTypes.number,
    dash: PropTypes.oneOf(strokeDashTypes),
  }).isRequired,
  strokeWeakRatio: PropTypes.shape({
    color: PropTypes.string,
    opacity: PropTypes.number,
    width: PropTypes.number,
    dash: PropTypes.oneOf(strokeDashTypes),
  }).isRequired,
  onContextMenu: PropTypes.func,
};

ShinoharaSeries.defaultProps = {
  className: "react-stockcharts-shinohara-series",
  strokeStrongRatio: { color: "#E99B54", opacity: 1, width: 1, dash: "Solid" }, // Orange (from ChartIQ)
  strokeWeakRatio: { color: "#5F7CB8", opacity: 1, width: 1, dash: "Solid" }, // Blue (from ChartIQ)
};

export default ShinoharaSeries;
